import CONSTANTS from "./constants";

const BASE_URL = `${CONSTANTS.CDN_URL}/static/img/social_icons`;

export const BRIGHTCOVE = `${BASE_URL}/brightcove-icon.svg`;
export const FACEBOOK = `${BASE_URL}/facebook-icon.svg`;
export const FACEBOOK_PAGE = `${BASE_URL}/facebook-icon.svg`;
export const S3 = `${BASE_URL}/s3-icon.svg`;
export const FTP = `${BASE_URL}/ftp-icon.svg`;
export const GRABYO = `${BASE_URL}/grabyo-icon.svg`;
export const SPREDFAST = `${BASE_URL}/spredfast-icon.svg`;
export const KHOROS = `${BASE_URL}/spredfast-icon.svg`;
export const PERISCOPE = `${BASE_URL}/periscope.svg`;
export const OOYALA = `${BASE_URL}/ooyala-icon.svg`; // Deprecated but keeping to support shared grabs
export const TWITCH = `${BASE_URL}/twitch-icon.svg`;
export const TWITTER = `${BASE_URL}/twitter-icon.svg`;
export const X = `${BASE_URL}/x-icon.svg`;
export const YOUTUBE = `${BASE_URL}/youtube-icon.svg`;
export const THEPLATFORM = `${BASE_URL}/theplatform-logo-plain.svg`;
export const COMCAST = `${BASE_URL}/theplatform-logo-plain.svg`;
export const TIKTOK = `${BASE_URL}/tiktok-icon.svg`;
export const INSTAGRAM = `${BASE_URL}/instagram-icon.svg`;
export const GLOBO = `${BASE_URL}/globo-logo.svg`;
export const GOOGLE_CLOUD_PLATFORM = `${BASE_URL}/google-clouds-storage.svg`;
export const MAGNIFI_ICON = `${BASE_URL}/magnifi-icon.png`;
export const THREADS = `${BASE_URL}/threads-logo.svg`;
